import React from 'react';

import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';
import Container from 'ravenjs/lib/Container';

const textStyle = {
    fontSize: '1.125rem',
    width: 'auto',
    margin: '0 auto 0 auto',
    lineHeight: '1.78',
    fontWeight: 400,
};

const Maintenance = () => {
    return (
        <Container>
            <Row padding="60px 0 60px 0">
                <img
                    src="https://cdn.trustmineral.com/assets/MIN-PrimaryLogo-TM-Citrine-RGB-01.png"
                    alt="Mineral™"
                    width="160"
                    height="35"
                />
            </Row>
            <Row padding="15px" margin="30px auto" width="650px">
                <Col>
                    <Row justify="center">
                        <img
                            src="https://cdn.trustmineral.com/assets/maintenance-mineral.png"
                            alt="Mineral™"
                            width="470"
                            height="320"
                        />
                    </Row>
                    <Row margin="45px 0 0">
                        <h1 style={{ ...textStyle, fontSize: '2.25rem', lineHeight: '2.5' }}>
                            <strong>Down for Maintenance</strong>
                        </h1>
                    </Row>
                    <Row>
                        <p style={textStyle}>This site is currently down for maintenance.</p>
                        <p style={textStyle}>We apologize for any inconvenience caused.</p>
                    </Row>
                    <Row margin="10px 0">
                        <p style={textStyle}>Thank you for your patience!</p>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default Maintenance;
